(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["urban-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /**
   * Initialise scroll-reveal for a single .urban-story root element.
   * Guards against double-init via data-us-init.
   */
  function initRoot(root) {
    /* Skip if already initialised */
    if (root.dataset.usInit) return;
    root.dataset.usInit = '1';

    /* Skip if merchant disabled motion for this section */
    if (root.dataset.motion === 'off') return;

    /* Skip if user prefers reduced motion or browser lacks IntersectionObserver */
    var prefersReduced = window.matchMedia &&
                         window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced || !window.IntersectionObserver) return;

    /* Activate animation mode — hides panels until they intersect */
    root.classList.add('us-anim');

    /* 2 500 ms failsafe: if observer never fires, make everything visible */
    var failsafe = setTimeout(function () {
      root.querySelectorAll('.us-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }, 2500);

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
        /* Once all panels are visible, cancel the failsafe */
        var allVisible = Array.prototype.every.call(
          root.querySelectorAll('.us-reveal'),
          function (el) { return el.classList.contains('is-visible'); }
        );
        if (allVisible) clearTimeout(failsafe);
      },
      { threshold: 0, rootMargin: '0px 0px -8% 0px' }
    );

    root.querySelectorAll('.us-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  /** Find and initialise every .urban-story on the page */
  function initAll() {
    document.querySelectorAll('.urban-story').forEach(initRoot);
  }

  /* Run on page load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-init after Shopify Theme Editor section:load events */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target ? event.target.querySelector('.urban-story') : null;
    if (section) {
      /* Reset the init guard so the section can be re-initialised */
      delete section.dataset.usInit;
      initRoot(section);
    }
  });
}());

  } catch(e) { console.error(e); }
})();
})();
